export default {
  workshop: {
    breadcrumbHome: 'Startseite',
    breadcrumbSolutions: 'Lösungen',
    breadcrumbCurrent: 'Werkstatt & Gewerbe',
    hero: {
      eyebrow: 'Werkstatt & Gewerbe',
      title: 'Robuste Sicherheitstechnik für den rauen Betrieb',
      lead: 'Staub, Feuchtigkeit, Temperaturschwankungen – Werkstätten stellen besondere Anforderungen. Wir montieren Kameras, die mithalten.',
    },
    areas: {
      title: 'Einsatzbereiche in Werkstatt und Gewerbe',
      lead: 'Vom Werkstattbereich bis zum Außenhof – wir sichern Ihre wertvollen Werkzeuge, Maschinen und Fahrzeuge.',
      items: {
        '0': { title: 'Werkhalle', desc: 'Hohe Hallen mit Maschinen und Werkstätten brauchen robuste Kameras mit guter Auflösung – auch bei schwierigem Licht.' },
        '1': { title: 'Werkstattbereich', desc: 'Werkzeug, Ersatzteile und laufende Aufträge: Überwachung schützt Ihre Arbeitsfläche und klärt Reklamationen.' },
        '2': { title: 'Ladezone', desc: 'Be- und Entladung sind Fenster für Diebstahl. Kameras an der Ladezone dokumentieren jeden Vorgang zuverlässig.' },
        '3': { title: 'Maschinenbereich', desc: 'Moderne Fertigung erfordert lückenlose Prozessdokumentation – auch über die Maschinen hinweg.' },
        '4': { title: 'Hof & Stellplatz', desc: 'Abgestellte Fahrzeuge, Anhänger und Material – der Hof braucht wetterfeste Kameras mit guter Nachtsicht.' },
        '5': { title: 'Büro & Verwaltung', desc: 'Angebote, Rechnungen und Kundendaten liegen im Büro. Auch hier gehört die Sicherheit nicht vernachlässigt.' },
      },
    },
    robust: {
      eyebrow: 'Robustheit',
      title: 'Gebaut für den harten Einsatz',
      lead: 'Werkstätten und Gewerbebetriebe sind keine Showrooms. Unsere Kameras sind für genau solche Umgebungen gebaut – und werden gezielt für Ihre Bedingungen ausgewählt.',
      items: {
        '0': { title: 'Hohe Schutzklasse', desc: 'Gehäuse nach IP66 schützen vor Staub, Spritzwasser und Regen – auch bei dauerhaftem Außeneinsatz.' },
        '1': { title: 'Temperatur- & Feuchtebeständig', desc: 'Von eisiger Lagerhalle bis zur warmen Werkstatt: Wir wählen Kameras für den jeweiligen Temperaturbereich.' },
        '2': { title: 'Staubgeschützte Gehäuse', desc: 'In staubigen Umgebungen halten spezielle Gehäuse und Dichtungen die Optik über Jahre hinweg sauber und scharf.' },
      },
    },
    maintenance: {
      eyebrow: 'Wartung & Betreuung',
      title: 'Damit Ihre Anlage zuverlässig bleibt',
      lead: 'In staubigen und rauen Umgebungen entscheidet die Pflege über die Lebensdauer. Mit SSG Care bleibt Ihre Anlage dauerhaft einsatzbereit.',
      list: {
        '0': 'Regelmäßige Checks durch SSG Care – auch außerhalb der Garantie',
        '1': 'Reinigung und Sichtprüfung von Gehäuse und Objektiv',
        '2': 'Firmware- und Sicherheitsupdates nach Bedarf',
        '3': 'Schnelle Reaktion bei Störungen oder Ausfällen',
        '4': 'Ersatzteil- und Aufrüstungsoptionen für Ihre Anlage',
      },
      note: 'Hinweis: Die rechtliche Zulässigkeit der Videoüberwachung hängt vom Einzelfall ab. Wir beraten Sie, ersetzen aber keine Rechtsberatung.',
    },
    cta: {
      title: 'Ihre Werkstatt verdient den sicheren Blick',
      lead: 'Wir beraten Sie unverbindlich, welche Kameras Ihre Umgebung aushalten – und wo sie am meisten schützen.',
      primary: 'Beratungstermin vereinbaren',
      secondary: 'SSG Care entdecken',
    },
  },
};